"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.activeMultiCurrencyUnSelected = exports.activeMultiCurrencySelected = exports.archiveMultiCurrency = exports.ArchiveMultiCurrency = exports.ArchiveMultiCurrencyActionTypes = exports.setMultiCurrency = exports.SetMultiCurrency = exports.SetMultiCurrencyActionTypes = exports.loadMultiCurrencies = exports.FetchMultiCurrencies = exports.FetchMultiCurrenciesActionTypes = exports.setCompanyCurrency = exports.SetCompanyCurrency = exports.SetCompanyCurrencyActionTypes = exports.loadCompanyCurrency = exports.FetchCompanyCurrency = exports.FetchCompanyCurrencyActionTypes = exports.loadMultiCurrencyActive = exports.FetchMultiCurrencyActive = exports.FetchMultiCurrencyActiveActionTypes = exports.loadMultiCurrencyCodes = exports.FetchMultiCurrencyCodes = exports.FetchMultiCurrencyCodesActionTypes = exports.MultiCurrencyActionTypes = void 0;

var _namespacedKeyMirror = _interopRequireDefault(require("settings-ui-lib/utils/namespacedKeyMirror"));

var _actions = require("settings-ui-lib/utils/actions");

var _createAction = _interopRequireDefault(require("flux-actions/createAction"));

var MultiCurrencyActionTypes = (0, _namespacedKeyMirror.default)({
  FETCH_MULTI_CURRENCY_ACTIVE: null,
  FETCH_MULTI_CURRENCY_CODES: null,
  FETCH_HOME_CURRENCY: null,
  SET_HOME_CURRENCY: null,
  FETCH_MULTI_CURRENCIES: null,
  SET_MULTI_CURRENCY: null,
  ARCHIVE_MULTI_CURRENCY: null,
  ACITVE_MULTI_CURRENCY_SELECTED: null,
  ACITVE_MULTI_CURRENCY_UNSELECTED: null
}, 'shared');
exports.MultiCurrencyActionTypes = MultiCurrencyActionTypes;
var FetchMultiCurrencyCodesActionTypes = (0, _actions.createRequestTypes)(MultiCurrencyActionTypes.FETCH_MULTI_CURRENCY_CODES);
exports.FetchMultiCurrencyCodesActionTypes = FetchMultiCurrencyCodesActionTypes;
var FetchMultiCurrencyCodes = (0, _actions.createRequestActions)(FetchMultiCurrencyCodesActionTypes);
exports.FetchMultiCurrencyCodes = FetchMultiCurrencyCodes;
var loadMultiCurrencyCodes = (0, _createAction.default)(MultiCurrencyActionTypes.FETCH_MULTI_CURRENCY_CODES);
exports.loadMultiCurrencyCodes = loadMultiCurrencyCodes;
var FetchMultiCurrencyActiveActionTypes = (0, _actions.createRequestTypes)(MultiCurrencyActionTypes.FETCH_MULTI_CURRENCY_ACTIVE);
exports.FetchMultiCurrencyActiveActionTypes = FetchMultiCurrencyActiveActionTypes;
var FetchMultiCurrencyActive = (0, _actions.createRequestActions)(FetchMultiCurrencyActiveActionTypes);
exports.FetchMultiCurrencyActive = FetchMultiCurrencyActive;
var loadMultiCurrencyActive = (0, _createAction.default)(MultiCurrencyActionTypes.FETCH_MULTI_CURRENCY_ACTIVE);
exports.loadMultiCurrencyActive = loadMultiCurrencyActive;
var FetchCompanyCurrencyActionTypes = (0, _actions.createRequestTypes)(MultiCurrencyActionTypes.FETCH_HOME_CURRENCY);
exports.FetchCompanyCurrencyActionTypes = FetchCompanyCurrencyActionTypes;
var FetchCompanyCurrency = (0, _actions.createRequestActions)(FetchCompanyCurrencyActionTypes);
exports.FetchCompanyCurrency = FetchCompanyCurrency;
var loadCompanyCurrency = (0, _createAction.default)(MultiCurrencyActionTypes.FETCH_HOME_CURRENCY);
exports.loadCompanyCurrency = loadCompanyCurrency;
var SetCompanyCurrencyActionTypes = (0, _actions.createRequestTypes)(MultiCurrencyActionTypes.SET_HOME_CURRENCY);
exports.SetCompanyCurrencyActionTypes = SetCompanyCurrencyActionTypes;
var SetCompanyCurrency = (0, _actions.createRequestActions)(SetCompanyCurrencyActionTypes);
exports.SetCompanyCurrency = SetCompanyCurrency;
var setCompanyCurrency = (0, _createAction.default)(MultiCurrencyActionTypes.SET_HOME_CURRENCY, (0, _actions.mapPayloadTo)('companyCurrencyCode', 'updatedCurrencyExchangeRates'));
exports.setCompanyCurrency = setCompanyCurrency;
var FetchMultiCurrenciesActionTypes = (0, _actions.createRequestTypes)(MultiCurrencyActionTypes.FETCH_MULTI_CURRENCIES);
exports.FetchMultiCurrenciesActionTypes = FetchMultiCurrenciesActionTypes;
var FetchMultiCurrencies = (0, _actions.createRequestActions)(FetchMultiCurrenciesActionTypes);
exports.FetchMultiCurrencies = FetchMultiCurrencies;
var loadMultiCurrencies = (0, _createAction.default)(MultiCurrencyActionTypes.FETCH_MULTI_CURRENCIES);
exports.loadMultiCurrencies = loadMultiCurrencies;
var SetMultiCurrencyActionTypes = (0, _actions.createRequestTypes)(MultiCurrencyActionTypes.SET_MULTI_CURRENCY);
exports.SetMultiCurrencyActionTypes = SetMultiCurrencyActionTypes;
var SetMultiCurrency = (0, _actions.createRequestActions)(SetMultiCurrencyActionTypes);
exports.SetMultiCurrency = SetMultiCurrency;
var setMultiCurrency = (0, _createAction.default)(MultiCurrencyActionTypes.SET_MULTI_CURRENCY, (0, _actions.mapPayloadTo)('fromCurrencyCode', 'toCurrencyCode', 'conversionMultiplier'));
exports.setMultiCurrency = setMultiCurrency;
var ArchiveMultiCurrencyActionTypes = (0, _actions.createRequestTypes)(MultiCurrencyActionTypes.ARCHIVE_MULTI_CURRENCY);
exports.ArchiveMultiCurrencyActionTypes = ArchiveMultiCurrencyActionTypes;
var ArchiveMultiCurrency = (0, _actions.createRequestActions)(ArchiveMultiCurrencyActionTypes);
exports.ArchiveMultiCurrency = ArchiveMultiCurrency;
var archiveMultiCurrency = (0, _createAction.default)(MultiCurrencyActionTypes.ARCHIVE_MULTI_CURRENCY, (0, _actions.mapPayloadTo)('fromCurrencyCode', 'toCurrencyCode'));
exports.archiveMultiCurrency = archiveMultiCurrency;

var activeMultiCurrencySelected = function activeMultiCurrencySelected(currencyCode) {
  return {
    type: MultiCurrencyActionTypes.ACITVE_MULTI_CURRENCY_SELECTED,
    payload: {
      currencyCode: currencyCode
    }
  };
};

exports.activeMultiCurrencySelected = activeMultiCurrencySelected;

var activeMultiCurrencyUnSelected = function activeMultiCurrencyUnSelected() {
  return {
    type: MultiCurrencyActionTypes.ACITVE_MULTI_CURRENCY_SELECTED
  };
};

exports.activeMultiCurrencyUnSelected = activeMultiCurrencyUnSelected;